import ResearchProjectsContent from '../components/ResearchProjectsContent';
import PageTemplate from '../components/PageTemplate';

const Projects = () => (
    <PageTemplate element={<ResearchProjectsContent/>} page={"projects"} />
);

export default Projects;